import type {
  ColumnField,
  ColumnGroup,
} from '../../../../shared/design-system/ui/tanstack-table/types';

export type CompanyColumnField = ColumnField;
export type CompanyColumnGroup = ColumnGroup;

export const ALL_COMPANY_COLUMN_FIELDS: CompanyColumnField[] = [
  // Default columns (Yes in CSV)
  {
    id: 'company_name',
    label: 'Company',
    isDefault: true,
    isNonRemovable: true,
  },
  { id: 'actions', label: 'Actions', isDefault: true },
  { id: 'socials', label: 'Socials', isDefault: true },
  { id: 'hq_location', label: 'Location', isDefault: true },
  { id: 'founded_year', label: 'Founded Year', isDefault: true },
  { id: 'industry', label: 'Industry', isDefault: true },
  { id: 'type', label: 'Type', isDefault: true },
  { id: 'is_b2b', label: 'Is B2B', isDefault: true },
  { id: 'sic_codes', label: 'SIC Codes', isDefault: true },
  { id: 'naics_codes', label: 'NAIC Codes', isDefault: true },
  { id: 'employee_count', label: 'Employee Count', isDefault: true },
  { id: 'list', label: 'List', isDefault: true },
  { id: 'tags', label: 'Tags', isDefault: true },

  // Non-default columns
  { id: 'categories_and_keywords', label: 'Categories & Keywords' },
  { id: 'technologies', label: 'Technologies' },
  { id: 'last_funding_round', label: 'Last funding round' },
  { id: 'last_raised_amount', label: 'Last raised amount' },
  { id: 'last_funding_date', label: 'Last funding date' },
  {
    id: 'last_funding_rounds_num_investors',
    label: 'Last Funding Round Num Investors',
  },
  { id: 'lead_investors', label: 'Lead Investors' },
  { id: 'funding_rounds_name', label: 'Funding Round' },
  // { id: 'funding_rounds_announced_date', label: 'Funding Round Date' },
  // { id: 'funding_rounds_amount_raised', label: 'Funding Round Amount' },
  // { id: 'funding_rounds_num_investors', label: 'Funding Round Investors' },
  { id: 'annual_revenue', label: 'Annual Revenue' },
  { id: 'employee_count_by_department', label: 'Employee Count by Department' },
  {
    id: 'employee_count_by_designation',
    label: 'Employee Count by Designation',
  },
  { id: 'projected_salary_title', label: 'Projected Salary - Title' },
  // { id: 'projected_salary_median', label: 'Projected Salary - Median' },
  { id: 'company_phone', label: 'Company Phone' },
  { id: 'company_email', label: 'Company Email' },
  { id: 'ownership_status', label: 'Ownership Type' },
  { id: 'competitors_company_name', label: 'Competitor Company' },
  // { id: 'competitors_similarity_score', label: 'Competitor Similarity' },
  // { id: 'competitors_competitors', label: 'Competitor Name' },
  // { id: 'competitors_website', label: 'Competitor Website' },
  { id: 'active_job_posting_count', label: 'Active Job Posting Count' },
  {
    id: 'active_job_posting_title_wise',
    label: 'Active Job Posting Title wise',
  },
  { id: 'top_topics', label: 'Top Topics' },
  // { id: 'product_services', label: 'Product & Services' },
  { id: 'website_visitor_count', label: 'Website Visitor Count' },
  {
    id: 'website_visitor_count_by_country',
    label: 'Website Visitor Count By Country',
  },
  {
    id: 'website_visitor_count_by_gender',
    label: 'Website Visitor Count By Gender',
  },
  { id: 'linkedin_followers', label: 'LinkedIn Followers' },
  { id: 'product_review_score', label: 'Product Review Score' },
  { id: 'employee_review_score', label: 'Employee review score' },
  { id: 'company_description', label: 'Company Description' },
  { id: 'headline_summary', label: 'Headline + Summary' },
  { id: 'ebit', label: 'Ebit' },
  { id: 'ebitda', label: 'Ebitda' },
  { id: 'ebitda_margin', label: 'Ebitda Margin' },
  { id: 'ebit_margin', label: 'Ebit Margin' },
  { id: 'gross_profit', label: 'Gross Profit' },
  { id: 'gross_profit_margin', label: 'Gross Profit Margin' },
  { id: 'net_income', label: 'Net Income' },
  { id: 'total_operating_expense', label: 'Total Operating Expense' },
  { id: 'cost_of_goods_sold', label: 'Cost Of Goods Sold' },
  { id: 'earning_per_share', label: 'Earning Per Share' },
  // { id: 'stock_closing_price', label: 'Stock Closing Price' },
  { id: 'stock_currency', label: 'Stock Information' },
  // { id: 'stock_date', label: 'Stock Date' },
  // { id: 'stock_marketcap', label: 'Stock Market Cap' },
  { id: 'key_executive_departure_name', label: 'Executive Departure - Name' },
  // { id: 'key_executive_departure_position', label: 'Executive Departure - Position' },
  // { id: 'key_executive_departure_date', label: 'Executive Departure - Date' },
  { id: 'key_executive_arrival_name', label: 'Executive Arrival - Name' },
  // { id: 'key_executive_arrival_position', label: 'Executive Arrival - Position' },
  // { id: 'key_executive_arrival_date', label: 'Executive Arrival - Date' },
  // { id: 'domain', label: 'Domain' },
  // { id: 'linkedin_url', label: 'LinkedIn' },
];

export const COMPANY_COLUMN_GROUPS: CompanyColumnGroup[] = [
  {
    id: 'company_info',
    title: 'Company Information',
    fields: [
      {
        id: 'company_name',
        label: 'Company',
        isDefault: true,
        isNonRemovable: true,
      },
      { id: 'socials', label: 'Socials', isDefault: true },
      { id: 'industry', label: 'Industry', isDefault: true },
      { id: 'type', label: 'Type', isDefault: true },
      { id: 'list', label: 'List', isDefault: true },
      { id: 'tags', label: 'Tags', isDefault: true },
      // { id: 'domain', label: 'Domain' },
      // { id: 'linkedin_url', label: 'LinkedIn' },
      { id: 'company_description', label: 'Company Description' },
      // { id: 'headline_summary', label: 'Headline + Summary' },
    ],
  },
  {
    id: 'size_location',
    title: 'Location & Size',
    fields: [
      { id: 'hq_location', label: 'Location', isDefault: true },
      { id: 'founded_year', label: 'Founded Year', isDefault: true },
      { id: 'employee_count', label: 'Employee Count', isDefault: true },
      {
        id: 'employee_count_by_department',
        label: 'Employee Count by Department',
      },
      {
        id: 'employee_count_by_designation',
        label: 'Employee Count by Designation',
      },
    ],
  },
  {
    id: 'financials',
    title: 'Financials',
    fields: [
      { id: 'annual_revenue', label: 'Annual Revenue' },
      { id: 'ebit', label: 'Ebit' },
      { id: 'ebitda', label: 'Ebitda' },
      { id: 'ebitda_margin', label: 'Ebitda Margin' },
      { id: 'ebit_margin', label: 'Ebit Margin' },
      { id: 'gross_profit', label: 'Gross Profit' },
      { id: 'gross_profit_margin', label: 'Gross Profit Margin' },
      { id: 'net_income', label: 'Net Income' },
      { id: 'total_operating_expense', label: 'Total Operating Expense' },
      { id: 'cost_of_goods_sold', label: 'Cost Of Goods Sold' },
      { id: 'earning_per_share', label: 'Earning Per Share' },
    ],
  },
  {
    id: 'funding',
    title: 'Funding',
    fields: [
      { id: 'last_funding_round', label: 'Last funding round' },
      { id: 'last_raised_amount', label: 'Last raised amount' },
      { id: 'last_funding_date', label: 'Last funding date' },
      {
        id: 'last_funding_rounds_num_investors',
        label: 'Last Funding Round Num Investors',
      },
      { id: 'lead_investors', label: 'Lead Investors' },
      { id: 'funding_rounds_name', label: 'Funding Round' },
      // { id: 'funding_rounds_announced_date', label: 'Funding Round Date' },
      // { id: 'funding_rounds_lead_investors', label: 'Funding Round Lead Investors' },
      // { id: 'funding_rounds_amount_raised', label: 'Funding Round Amount' },
      // { id: 'funding_rounds_num_investors', label: 'Funding Round Investors' },
    ],
  },
  {
    id: 'stock_info',
    title: 'Stock Information',
    fields: [
      // { id: 'stock_closing_price', label: 'Stock Closing Price' },
      { id: 'stock_currency', label: 'Stock Information' },
      // { id: 'stock_date', label: 'Stock Date' },
      // { id: 'stock_marketcap', label: 'Stock Market Cap' },
    ],
  },
  {
    id: 'business_metrics',
    title: 'Business Metrics',
    fields: [
      { id: 'is_b2b', label: 'Is B2B', isDefault: true },
      { id: 'sic_codes', label: 'SIC Codes', isDefault: true },
      { id: 'naics_codes', label: 'NAIC Codes', isDefault: true },
      { id: 'ownership_status', label: 'Ownership Type' },
      { id: 'categories_and_keywords', label: 'Categories & Keywords' },
      { id: 'technologies', label: 'Technologies' },
    ],
  },
  {
    id: 'people_jobs',
    title: 'People & Jobs',
    fields: [
      { id: 'active_job_posting_count', label: 'Active Job Posting Count' },
      {
        id: 'active_job_posting_title_wise',
        label: 'Active Job Posting Title wise',
      },
      { id: 'top_topics', label: 'Top Topics' },
      { id: 'projected_salary_title', label: 'Projected Salary - Title' },
      // { id: 'projected_salary_median', label: 'Projected Salary - Median' },
      {
        id: 'key_executive_departure_name',
        label: 'Executive Departure - Name',
      },
      // { id: 'key_executive_departure_position', label: 'Executive Departure - Position' },
      // { id: 'key_executive_departure_date', label: 'Executive Departure - Date' },
      { id: 'key_executive_arrival_name', label: 'Executive Arrival - Name' },
      // { id: 'key_executive_arrival_position', label: 'Executive Arrival - Position' },
      // { id: 'key_executive_arrival_date', label: 'Executive Arrival - Date' },
    ],
  },
  {
    id: 'competitors',
    title: 'Competitors',
    fields: [
      { id: 'competitors_company_name', label: 'Competitor Company' },
      // { id: 'competitors_similarity_score', label: 'Competitor Similarity' },
      // { id: 'competitors_competitors', label: 'Competitor Name' },
      // { id: 'competitors_website', label: 'Competitor Website' },
    ],
  },
  {
    id: 'engagement',
    title: 'Engagement',
    fields: [
      { id: 'website_visitor_count', label: 'Website Visitor Count' },
      {
        id: 'website_visitor_count_by_country',
        label: 'Website Visitor Count By Country',
      },
      {
        id: 'website_visitor_count_by_gender',
        label: 'Website Visitor Count By Gender',
      },
      { id: 'linkedin_followers', label: 'LinkedIn Followers' },
    ],
  },
  {
    id: 'reviews_topics',
    title: 'Reviews & Topics',
    fields: [
      { id: 'product_review_score', label: 'Product Review Score' },
      { id: 'employee_review_score', label: 'Employee review score' },
      // { id: 'top_topics', label: 'Top Topics' },
      // { id: 'product_services', label: 'Product & Services' },
    ],
  },
  {
    id: 'contact',
    title: 'Contact',
    fields: [
      { id: 'company_phone', label: 'Company Phone' },
      { id: 'company_email', label: 'Company Email' },
    ],
  },
  {
    id: 'actions_group',
    title: 'Actions',
    fields: [
      {
        id: 'actions',
        label: 'Actions',
        isDefault: true,
      },
    ],
  },
];

export const getDefaultCompanyColumns = (): CompanyColumnField[] =>
  ALL_COMPANY_COLUMN_FIELDS.filter((field) => field.isDefault);

// Separate localStorage key for company column preferences
export const COMPANY_COLUMN_PREFERENCES_KEY = 'v2-company-column-preferences';
